import React from 'react'
import frikko from '../img/frikko.png'
import york from '../img/york.png'
import max from '../img/max.png'
import rheem from '../img/rheem.png'
import airon from '../img/airon.png'
import '../estilos/Footer.css'

function Footer () {
  return (
    <div className='footer'>
        <div>
        <p>
        <a href='https://www.frikko.com' target='_blank' rel='noreferrer'><img src={frikko} alt='frikko' className='logo'></img></a>
        <img src={york} alt='york' className='logo'></img>
        <a href='https://www.frikko.com' target='_blank' rel='noreferrer'><img src={max} alt='max' className='logo'></img></a>
        <img src={rheem} alt='rheem' className='logo__rem'></img>
        <a href='https://www.frikko.com' target='_blank' rel='noreferrer'><img src={airon} alt='airon' className='logo__airon'></img></a>
        </p>
        </div>
    </div>
  )
}
export default Footer
